import { Select } from 'components/ui/base/select/Select';
import styled from 'styled-components';

export const StyledDeclarationSelect = styled(Select)<{ condensed?: boolean; lock: boolean }>`
    width: 100%;
    font-weight: normal;

    .ant-select-selector {
        border-radius: ${({ condensed }) => (condensed ? '6px !important' : 'initial')};
        ${({ lock }) => lock && 'border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;'}
        border: ${({ condensed }) => (condensed ? '1px solid #cecece !important' : 'initial')};
    }

    .ant-select-arrow-loading {
        color: var(--brand-6);
    }
`;
